import {
  Box,
  TextField,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormLabel,
  FormHelperText,
  Edit,
} from "@pankod/refine-mui";
import { Controller, useForm } from "@pankod/refine-react-hook-form";
import { REST_PUBLIC_URI } from "environment";
import { AxiosInstance } from "axios";
import { axiosInstance } from "@pankod/refine-simple-rest";
import { useState } from "react";

interface data {
  url: string;
}

interface fileUpload {
  data: data;
}

const allowedExtension = ["image/jpeg", "image/jpg", "image/png"];

const upload = async (base64: File) => {
  const x = new FormData();

  x.append("file", base64);
  const httpClient: AxiosInstance = axiosInstance;
  const url = `${REST_PUBLIC_URI}/api/admin/v1/upload-file`;

  const data: fileUpload = await httpClient.post(url, x);

  return data;
};

export const BannerEdit = () => {
  const onChangeHandler = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    try {
      setError(false);
      const target = event.target;
      const file: File = (target.files as FileList)[0];
      if (!allowedExtension.includes(file.type)) {
        setError(true);
        setHelperText("Only image is allowed");
        return;
      }
      const banner_url = await upload(file);
      setValue("banner_url", banner_url.data.url, { shouldValidate: true });
    } catch (error) {
      setHelperText(error as string);
      setError(true);
    }
  };
  const {
    saveButtonProps,
    register,
    control,
    setValue,
    formState: { errors },
  } = useForm();

  const [error, setError] = useState<boolean>(false);
  const [helperText, setHelperText] = useState<string>("Only image is allowed");

  return (
    <Edit saveButtonProps={saveButtonProps}>
      <Box
        component="form"
        sx={{ display: "flex", flexDirection: "column" }}
        autoComplete="off"
      >
        <TextField
          {...register("banner_id")}
          required
          error={!!(errors as any)?.banner_id}
          helperText={(errors as any)?.banner_id?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="number"
          label="banner_id"
          name="banner_id"
          disabled
        />
        <TextField
          onChange={onChangeHandler}
          error={error}
          helperText={error ? helperText : null}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="file"
          label="File"
          name="file"
        />
        <TextField
          style={{ display: "none" }}
          {...register("logo_url")}
          disabled
          error={!!(errors as any)?.logo_url}
          helperText={(errors as any)?.logo_url?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="text"
          label="Logo Url"
          name="logo_url"
        />
        <TextField
          {...register("priority", {
            required: "This field is required",
          })}
          required
          error={!!(errors as any)?.priority}
          helperText={(errors as any)?.priority?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="number"
          label="Priority"
          name="priority"
        />
         <TextField
          {...register("target_url")}
          error={!!(errors as any)?.target_url}
          helperText={(errors as any)?.target_url?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="string"
          label="Banner Target URL"
          name="target_url"
        />
        <Controller
          control={control}
          name="is_enable"
          render={({ field: { onChange, value } }) => (
            <FormControl required error={!!(errors as any)?.is_enable}>
              <FormLabel>Is_Enable</FormLabel>
              <RadioGroup
                row
                onChange={(_, value) => onChange(value === "true")}
                value={value}
              >
                <FormControlLabel
                  control={<Radio />}
                  label="True"
                  value={true}
                />
                <FormControlLabel
                  control={<Radio />}
                  label="False"
                  value={false}
                />
              </RadioGroup>
              <FormHelperText>
                {(errors as any)?.is_enable?.message}
              </FormHelperText>
            </FormControl>
          )}
        />
      </Box>
    </Edit>
  );
};
